import { render, staticRenderFns } from "./ProposalCreate.vue?vue&type=template&id=4583cdfd&scoped=true&"
import script from "./ProposalCreate.vue?vue&type=script&lang=js&"
export * from "./ProposalCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCreate.vue?vue&type=style&index=0&id=4583cdfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583cdfd",
  null
  
)

export default component.exports